import { FC, ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';

const CurbsideNotificationSkeletons: FC = (): ReactElement => {
  return (
    <div className="d-flex flex-column gap-10">
      <Skeleton width={150} height={21.59} className="mb-2" />
      <Skeleton width={200} height={21.59} />

      <Skeleton width={360} height={46} style={{ borderRadius: 12 }} />
      <Skeleton width={450} height={46} style={{ borderRadius: 12 }} />

      <div className="d-flex flex-column gap-10">
        <Skeleton width={450} height={143} style={{ borderRadius: 10 }} />
        <Skeleton width={30} height={16.8} />
      </div>
    </div>
  );
};

export default CurbsideNotificationSkeletons;
